import React, { ReactNode } from "react"
import { css, cx } from "@emotion/css"
import Box, { BoxProps } from "@material-ui/core/Box"

const styles = {
  root: css`
    background-color: transparent;
    overflow-x: hidden;
    overflow-y: auto;
  `,
  variants: {
    default: css`
      border-radius: 2px;
      background-color: var(--white);
    `,
    filled: css`
      border-radius: 6px;
      border: solid 1px #cbcbcb;
      background-color: var(--light-grey);
    `,
    ghost: css`
      border: none;
    `,
    custom: css``,
  },
  sizes: {
    default: css`
      padding: var(--spacing-m);
    `,
    dense: css`
      padding: var(--spacing-xs);
    `,
    ghost: css`
      padding: 0;
    `,
    custom: css``,
  },
}

export type SurfaceProps = {
  children: ReactNode
  className?: string
  variant?: "default" | "filled" | "ghost" | "custom"
  size?: "default" | "dense" | "ghost" | "custom"
} & BoxProps

export function Surface(props: SurfaceProps) {
  const {
    children,
    className,
    //
    variant = "default",
    size = "default",
    //
    ...box
  } = props

  const cn = cx(
    styles.root,
    //
    styles.variants[variant],
    styles.sizes[size],
    className,
  )

  return (
    <Box {...box} className={cn}>
      {children}
    </Box>
  )
}

export default Surface
